export const deferralsPtBr = {
  toggle: {
    label: 'Diferimento',
    labelActive: 'Diferimento ativo',
    labelInactive: 'Sem diferimento',
    lockedTooltip: 'Estorne a contabilização da NF para alterar o diferimento.',
    suggestEnable: 'Configurar diferimento',
  },
  infoBanner: {
    suggestionTitle: 'Esta nota pode ser um contrato recorrente',
    suggestionDescription:
      'Notas com valor alto ou recorrentes geralmente se beneficiam do reconhecimento mensal pela competência. Habilite o diferimento para distribuir a despesa no período contratado.',
    suggestionCta: 'Configurar diferimento',
    activeTitle: 'Diferimento ativo',
    activeDescription:
      'Esta nota será apropriada em {{months}} meses ({{monthly}} por mês, de {{start}} a {{end}}).',
    draftTitle: 'Diferimento em rascunho',
    draftDescription:
      'Plano de apropriação salvo: {{months}} meses ({{monthly}} por mês, de {{start}} a {{end}}). Será ativado quando a nota for aprovada e contabilizada.',
    draftHint: 'Ainda não há impacto contábil. O cronograma só começa após a aprovação da NF.',
    editCta: 'Editar',
    cancelCta: 'Cancelar diferimento',
    removeCta: 'Remover diferimento',
    removeConfirm:
      'Remover o diferimento desta nota? O cronograma salvo será descartado. Você pode criar um novo diferimento depois.',
    cancelConfirm: 'Cancelar o diferimento desta nota?',
    removedToast: 'Diferimento removido da nota.',
    cancelledToast: 'Diferimento cancelado.',
  },
  drawer: {
    title: 'Diferimento / Despesa Antecipada',
    description:
      'Configure como o valor da nota será reconhecido mensalmente no regime de competência.',
    fields: {
      recognitionMethod: 'Método de reconhecimento',
      recognitionMethodMonthly: 'Mensal (meses cheios, pro-rata no primeiro/último)',
      recognitionMethodDaily: 'Pro-rata diário',
      startDate: 'Início da competência',
      endDate: 'Fim da competência',
      prepaidSlot: 'Conta de Despesas Antecipadas',
      prepaidSlotCirculante: 'Ativo Circulante (até 12 meses)',
      prepaidSlotLongoPrazo: 'Realizável a Longo Prazo (+12 meses)',
      firstInstallmentOverride: 'Valor da primeira parcela (opcional)',
      firstInstallmentOverridePlaceholder: 'Deixe em branco para distribuição automática',
      firstInstallmentOverrideHelp:
        'Deixe em branco para distribuição automática. As demais parcelas do mesmo grupo (CP ou LP) serão redistribuídas.',
      firstInstallmentOverrideHint: 'Limite do grupo inicial: {{max}}',
      notes: 'Observações',
      notesPlaceholder: 'Ex.: HubSpot anual 2026 — parcela trimestral jan-mar.',
    },
    durationShortcuts: {
      label: 'Duração',
      months: '{{count}} meses',
    },
    preview: {
      title: 'Cronograma de apropriação',
      month: 'Mês',
      bucket: 'Conta',
      amount: 'Valor',
      remainingBalance: 'Saldo remanescente',
      totalRow: 'Total',
      catchupBadge: 'Catch-up',
      catchupAccumulated: 'Apropriação acumulada: {{amount}}',
      absorbedInto: 'Absorvida em {{period}}',
    },
    accountSelector: {
      shortTermLabel: 'Conta de Despesas Antecipadas — Ativo Circulante',
      shortTermHelp: 'Conta do ativo que receberá o valor até a apropriação mensal (CP).',
      longTermLabel: 'Conta de Despesas Antecipadas — Realizável a Longo Prazo',
      longTermHelp:
        'Obrigatório porque o diferimento ultrapassa 12 meses. Informe a conta de Realizável a Longo Prazo (LP).',
    },
    slotShortcut: {
      successTitle: 'Conta de Despesas Antecipadas configurada',
      successDescription: '{{accountNumber}} — {{accountName}}',
      changeLink: 'Alterar em Configurações → Contas de Sistema',
      unmappedTitle: 'Conta de Despesas Antecipadas ainda não está configurada',
      unmappedDescription:
        'Selecione a conta contábil do ativo (Despesa Antecipada) que receberá o valor até a apropriação mensal. Essa configuração é feita uma única vez e vale para todos os diferimentos.',
      selectAccountPlaceholder: 'Selecione a conta do ativo...',
      saveButton: 'Salvar conta',
      saveSuccess: 'Conta de Despesas Antecipadas configurada com sucesso.',
      openSettingsLink: 'Abrir tela de configuração',
    },
    actions: {
      save: 'Salvar diferimento',
      cancel: 'Cancelar diferimento',
      remove: 'Remover diferimento',
      close: 'Fechar',
    },
  },
  dashboard: {
    title: 'Diferimentos / Despesas Antecipadas',
    subtitle: 'Contratos com reconhecimento diferido da despesa no regime de competência.',
    kpis: {
      draft: 'Em rascunho',
      active: 'Ativos',
      totalBalance: 'Saldo a apropriar',
      currentMonth: 'Apropriar no mês',
      next30Days: 'Próximos 30 dias',
    },
    filters: {
      entity: 'Entidade',
      vendor: 'Fornecedor',
      status: 'Status',
      period: 'Período',
      startDate: 'Início',
      endDate: 'Fim',
    },
    actions: {
      runMonthlyBatch: 'Apropriar pendentes',
      runMonthlyBatchConfirm:
        'Isso irá postar todas as parcelas pendentes até o final de {{month}} (incluindo meses em atraso). Deseja continuar?',
      runMonthlyBatchSuccess: '{{successCount}} de {{totalCount}} apropriações postadas.',
      recognizeRow: 'Apropriar',
      recognizeRowTooltip:
        'Postar todas as parcelas pendentes deste diferimento até o mês atual, inclusive meses em atraso.',
      recognizeRowConfirm:
        'Postar {{count}} parcela(s) pendente(s) do diferimento de {{vendor}} até {{month}}?',
      recognizeRowSuccess:
        '{{successCount}} de {{totalCount}} parcelas apropriadas para este diferimento.',
      cancel: 'Cancelar diferimento',
      cancelTooltip: 'Cancelar',
      cancelConfirm:
        'Tem certeza que deseja cancelar o diferimento de {{vendor}}? Parcelas pendentes serão canceladas.',
      cancelSuccess: 'Diferimento cancelado.',
    },
    table: {
      vendor: 'Fornecedor',
      originBillLink: 'Ver nota de origem',
      description: 'Descrição',
      method: 'Método',
      period: 'Período',
      total: 'Total',
      balance: 'Saldo',
      monthly: 'Mensal',
      nextPeriod: 'Próxima apropriação',
      nextPeriodNa: 'N/A',
      status: 'Status',
      actions: 'Ações',
      empty: 'Nenhum diferimento encontrado no período.',
      overdueCount_one: '{{count}} parcela em atraso',
      overdueCount_other: '{{count}} parcelas em atraso',
    },
    cancelDialog: {
      title: 'Cancelar diferimento',
      lead: 'As parcelas pendentes de apropriação serão canceladas. Valores já reconhecidos no razão não são desfeitos automaticamente.',
      vendorLabel: 'Fornecedor',
      billLabel: 'Nota fiscal',
      openBill: 'Abrir nota',
      periodLabel: 'Período de competência',
      totalLabel: 'Valor total do diferimento',
      pendingLabel: 'Saldo a apropriar (pendente)',
      postedLabel: 'Já apropriado (postado)',
      cascadeTitle: 'O que fazer com a NF contabilizada?',
      cascadeReopenLabel: 'Reabrir para reaprovação',
      cascadeReopenHint: 'A NF volta para aprovação pendente sem diferimento.',
      cascadeVoidLabel: 'Cancelar NF (VOID)',
      cascadeVoidHint: 'A NF é marcada como VOID. Ação destrutiva.',
      cascadeWarningTitle: 'Estorno contábil automático',
      cascadeWarningBody:
        'O lançamento contábil da NF será estornado. Somente aprovadores master podem executar esta ação.',
      cascadePermissionError: 'Apenas aprovadores master podem estornar NF contabilizada.',
      plainReversalBody:
        'Nenhum lançamento contábil foi efetuado para esta NF; o diferimento será simplesmente descartado.',
      confirm: 'Confirmar cancelamento',
      dismiss: 'Voltar',
    },
    statusBadge: {
      DRAFT: 'Rascunho',
      ACTIVE: 'Ativo',
      COMPLETED: 'Concluído',
      CANCELLED: 'Cancelado',
    },
    statusBadgeHint: {
      DRAFT: 'Salvo, mas ainda não contabilizado. Será ativado na aprovação da NF.',
    },
    scheduleStatus: {
      PENDING: 'Pendente',
      POSTED: 'Postado',
      REVERSED: 'Estornado',
      CANCELLED: 'Cancelado',
    },
  },
  recurringBadge: {
    label: 'Diferimento',
    tooltip: 'Nota com diferimento — valor reconhecido mensalmente pelo regime de competência.',
  },
  alerts: {
    sectionTitle: 'Alertas de diferimentos',
    emptyTitle: 'Nenhum alerta ativo',
    emptyDescription: 'Todos os diferimentos estão em dia.',
    viewMore: 'Ver detalhes',
  },
  errors: {
    toastPrefix: 'Erro ao processar diferimento',
    unknown: 'Ocorreu um erro inesperado. Tente novamente.',
  },
  closing: {
    itemTitle: 'Revisar despesas antecipadas do mês',
    itemDescription: 'Verifique se todas as apropriações do mês foram postadas no razão.',
    itemAction: 'Revisar diferimentos',
  },
};

export const deferralsEn = {
  toggle: {
    label: 'Deferral',
    labelActive: 'Deferral active',
    labelInactive: 'No deferral',
    lockedTooltip: 'Reverse the bill GL posting to change the deferral.',
    suggestEnable: 'Configure deferral',
  },
  infoBanner: {
    suggestionTitle: 'This bill might be a recurring contract',
    suggestionDescription:
      'High-value or recurring bills usually benefit from monthly recognition under the accrual basis. Enable the deferral to spread the expense across the contract period.',
    suggestionCta: 'Configure deferral',
    activeTitle: 'Deferral active',
    activeDescription:
      'This bill will be recognized across {{months}} months ({{monthly}} each, {{start}} → {{end}}).',
    draftTitle: 'Deferral in draft',
    draftDescription:
      'Recognition plan saved: {{months}} months ({{monthly}} each, {{start}} → {{end}}). It will become active once the bill is approved and posted.',
    draftHint: 'No GL impact yet. The schedule starts only after the bill is approved.',
    editCta: 'Edit',
    cancelCta: 'Cancel deferral',
    removeCta: 'Remove deferral',
    removeConfirm:
      'Remove the deferral from this bill? The saved schedule will be discarded. You can create a new one later.',
    cancelConfirm: 'Cancel the deferral for this bill?',
    removedToast: 'Deferral removed from the bill.',
    cancelledToast: 'Deferral cancelled.',
  },
  drawer: {
    title: 'Deferral / Prepaid Expense',
    description:
      'Configure how the bill amount will be recognized monthly under the accrual basis.',
    fields: {
      recognitionMethod: 'Recognition method',
      recognitionMethodMonthly: 'Monthly (full months; first/last pro-rated)',
      recognitionMethodDaily: 'Daily pro-rata',
      startDate: 'Period start',
      endDate: 'Period end',
      prepaidSlot: 'Prepaid Expense account',
      prepaidSlotCirculante: 'Current asset (≤12 months)',
      prepaidSlotLongoPrazo: 'Non-current asset (>12 months)',
      firstInstallmentOverride: 'First installment amount (optional)',
      firstInstallmentOverridePlaceholder: 'Leave blank for automatic distribution',
      firstInstallmentOverrideHelp:
        'Leave blank for automatic distribution. The remaining entries in the same bucket will be redistributed automatically.',
      firstInstallmentOverrideHint: 'Initial bucket limit: {{max}}',
      notes: 'Notes',
      notesPlaceholder: 'e.g.: HubSpot 2026 — quarterly Jan-Mar.',
    },
    durationShortcuts: {
      label: 'Duration',
      months: '{{count}} months',
    },
    preview: {
      title: 'Recognition schedule',
      month: 'Month',
      bucket: 'Account',
      amount: 'Amount',
      remainingBalance: 'Remaining balance',
      totalRow: 'Total',
      catchupBadge: 'Catch-up',
      catchupAccumulated: 'Accumulated recognition: {{amount}}',
      absorbedInto: 'Absorbed into {{period}}',
    },
    accountSelector: {
      shortTermLabel: 'Prepaid Expense account — Current asset',
      shortTermHelp:
        'Asset account that will hold the amount until monthly recognition (short term).',
      longTermLabel: 'Prepaid Expense account — Non-current asset',
      longTermHelp:
        'Required because the deferral spans more than 12 months. Pick the non-current asset account (long term).',
    },
    slotShortcut: {
      successTitle: 'Prepaid Expense account configured',
      successDescription: '{{accountNumber}} — {{accountName}}',
      changeLink: 'Change in Settings → System Accounts',
      unmappedTitle: 'Prepaid Expense account is not configured yet',
      unmappedDescription:
        'Select the asset GL account (Prepaid Expense) that will hold the amount until monthly recognition. This is configured once and applies to every deferral.',
      selectAccountPlaceholder: 'Select asset account...',
      saveButton: 'Save account',
      saveSuccess: 'Prepaid Expense account saved.',
      openSettingsLink: 'Open settings page',
    },
    actions: {
      save: 'Save deferral',
      cancel: 'Cancel deferral',
      remove: 'Remove deferral',
      close: 'Close',
    },
  },
  dashboard: {
    title: 'Deferrals / Prepaid Expenses',
    subtitle: 'Contracts with deferred expense recognition under the accrual basis.',
    kpis: {
      draft: 'Draft',
      active: 'Active',
      totalBalance: 'Balance to recognize',
      currentMonth: 'Recognize this month',
      next30Days: 'Next 30 days',
    },
    filters: {
      entity: 'Entity',
      vendor: 'Vendor',
      status: 'Status',
      period: 'Period',
      startDate: 'Start',
      endDate: 'End',
    },
    actions: {
      runMonthlyBatch: 'Post pending',
      runMonthlyBatchConfirm:
        'This will post every pending schedule up to the end of {{month}} (including overdue months). Continue?',
      runMonthlyBatchSuccess: '{{successCount}} of {{totalCount}} recognitions posted.',
      recognizeRow: 'Post',
      recognizeRowTooltip:
        'Post all pending schedules for this deferral up to the current month, including overdue months.',
      recognizeRowConfirm: 'Post {{count}} pending schedule(s) for {{vendor}} up to {{month}}?',
      recognizeRowSuccess: '{{successCount}} of {{totalCount}} schedules posted for this deferral.',
      cancel: 'Cancel deferral',
      cancelTooltip: 'Cancel',
      cancelConfirm:
        'Are you sure you want to cancel the deferral for {{vendor}}? Pending schedules will be cancelled.',
      cancelSuccess: 'Deferral cancelled.',
    },
    table: {
      vendor: 'Vendor',
      originBillLink: 'View source bill',
      description: 'Description',
      method: 'Method',
      period: 'Period',
      total: 'Total',
      balance: 'Balance',
      monthly: 'Monthly',
      nextPeriod: 'Next recognition',
      nextPeriodNa: 'N/A',
      status: 'Status',
      actions: 'Actions',
      empty: 'No deferrals in the selected window.',
      overdueCount_one: '{{count}} overdue schedule',
      overdueCount_other: '{{count}} overdue schedules',
    },
    cancelDialog: {
      title: 'Cancel deferral',
      lead: 'Pending recognition lines will be cancelled. Amounts already posted to the GL are not automatically reversed.',
      vendorLabel: 'Vendor',
      billLabel: 'Invoice',
      openBill: 'Open bill',
      periodLabel: 'Recognition period',
      totalLabel: 'Total deferral amount',
      pendingLabel: 'Balance to recognize (pending)',
      postedLabel: 'Already recognized (posted)',
      cascadeTitle: 'What should happen to the posted bill?',
      cascadeReopenLabel: 'Reopen for approval',
      cascadeReopenHint: 'The bill returns to pending approval without deferral.',
      cascadeVoidLabel: 'Void the bill',
      cascadeVoidHint: 'The bill is marked VOID. Destructive action.',
      cascadeWarningTitle: 'Automatic GL reversal',
      cascadeWarningBody:
        'The bill GL posting will be reversed. Only master approvers can perform this action.',
      cascadePermissionError: 'Only master approvers can reverse a posted bill.',
      plainReversalBody: 'No GL posting exists for this bill; the deferral will be discarded.',
      confirm: 'Confirm cancellation',
      dismiss: 'Back',
    },
    statusBadge: {
      DRAFT: 'Draft',
      ACTIVE: 'Active',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled',
    },
    statusBadgeHint: {
      DRAFT: 'Saved but not yet posted. Becomes active when the bill is approved.',
    },
    scheduleStatus: {
      PENDING: 'Pending',
      POSTED: 'Posted',
      REVERSED: 'Reversed',
      CANCELLED: 'Cancelled',
    },
  },
  recurringBadge: {
    label: 'Deferral',
    tooltip: 'Bill with deferred recognition — amount recognized monthly.',
  },
  alerts: {
    sectionTitle: 'Deferral alerts',
    emptyTitle: 'No active alerts',
    emptyDescription: 'All deferrals are on track.',
    viewMore: 'View details',
  },
  errors: {
    toastPrefix: 'Deferral error',
    unknown: 'Unexpected error. Please try again.',
  },
  closing: {
    itemTitle: 'Review prepaid expenses for the month',
    itemDescription: 'Make sure every monthly recognition has been posted to the GL.',
    itemAction: 'Review deferrals',
  },
};
